import { render, staticRenderFns } from "./OvertimeNightLegend.vue?vue&type=template&id=5aeac7d8&"
import script from "./OvertimeNightLegend.vue?vue&type=script&lang=js&"
export * from "./OvertimeNightLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aeac7d8')) {
      api.createRecord('5aeac7d8', component.options)
    } else {
      api.reload('5aeac7d8', component.options)
    }
    module.hot.accept("./OvertimeNightLegend.vue?vue&type=template&id=5aeac7d8&", function () {
      api.rerender('5aeac7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/OvertimeNightLegend.vue"
export default component.exports